// extracted by mini-css-extract-plugin
export default {"button":"alert_button__Y3tnZ","button2":"alert_button2__ddBKV","container":"alert_container__vNUJU"};